import styled, { css } from "styled-components";

const dragActive = css`
  border-color: #78e5d5;
`;

const dragReject = css`
  border-color: #e57876;
`;

export const Form = styled.form`
  width: 100%;
`;

export const InputContainer = styled.div`
  width: 100%;
  height: 292px;

  margin-top: 20px;

  background: rgba(236, 242, 251, 0.4);
  border: 1px dashed #808b9f;
  border-radius: 20px;

  div {
    position: absolute;
    display: flex;
    flex-direction: column;
    top: 292px;

    width: 40%;
    height: 292px;
    gap: 20px;

    align-items: center;
    justify-content: center;
  }

  h3 {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    /* 1 */

    color: #4a5e83;
  }
`;

export const Input = styled.input`
  /* width: 100%;
    max-width: 600px;
    height: 200px;
    margin-top: 20px; */
  /* position: relative; 
    width: ...px; 
    height: ...px; overflow: hidden;  */
  width: 100%;
  height: 292px;
  position: relative;
  right: 0;
  font-size: 14px;
  opacity: 0;
  margin: 0;
  padding: 0;
  border: none;
`;

export const FieldText = styled.p`
  height: 24px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 24px;

  margin-bottom: 5px;

  color: #4a5e83;
`;

type DropContainerProps = { isDragActive: boolean; isDragReject: boolean };
export const DropContainer = styled.div.attrs({
  className: "dropzone",
})<DropContainerProps>`
  border: 1px dashed #ddd;
  border-radius: 4px;
  cursor: pointer;

  transition: height 0.2s ease;

  ${(props) => props.isDragActive && dragActive}
  ${(props) => props.isDragReject && dragReject}
`;
